import { PreviewCourseV2Dto } from '@/shared/interfaces/generated';

export const normilizeProducts = (arr: PreviewCourseV2Dto[]) => {
  return arr.map((item) => item.product);
};
